<template>
  <div
    class="StorageExplorerItemRow relative h-12 flex flex-row justify-start items-center gap-2 border-t-1 border-gray-300 cursor-pointer"
    @click.prevent.stop="handleItemClick($event.shiftKey)"
  >
    <div
      class="h-full flex items-center justify-center relative"
      style="aspect-ratio: 1;"
    >
      <aw-icon 
        v-if="isDirectory"
        icon="folder-filled" 
        class="h-10 w-10 text-bc-blue" 
      />
      <img
        v-else-if="previewImage"
        :src="previewImage"
        alt=""
        class="h-auto w-auto"
      />
      <file-icon 
        v-else
        :ext="item.ext" 
        size="small" 
        class="text-gray-400" 
      />
    </div>
    <span class="inline-block max-w-full text-sm truncate">
      {{ item.name }}
    </span>
    <div class="DataUpload__MetaData ml-auto h-full flex flex-row items-center justify-between gap-2 text-sm text-gray-300">
      <span class="DataUpload__Date text-sm hidden sm:inline-block">
        {{ formatDate(item.uploaded, 'd.m.y') }}
      </span>
      <span class="DataUpload__Size text-sm hidden sm:inline-block">
        <template v-if="item.size">
          {{ formatBytes(item.size) }}
        </template>
      </span>
      <span
        v-if="isDirectory" 
        class="w-4 mr-2"
      />
      <span
        v-else
        ref="DocumentCircle"
        :data-modal-item-index="index"
        class="DocumentCircle mr-2"
        :class="{ 'DocumentCircle--active': isSelected }"
        @click.prevent.stop="select($event.shiftKey)"
      />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcLinkStore from '@/frontapp/store/bcLink'
import useBcFileStore from '@/frontapp/store/bcFile'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import StorageExplorerItem from '../../mixins/StorageExplorerItem'

export default {
  mixins: [
    StorageExplorerItem
  ],
  props: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapStores(useBcLinkStore, useBcFileStore, useBcSelectedStore),
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.DataUpload__Date,
.DataUpload__Size {
  min-width: 5rem;
  @apply text-right;
}
</style>
